/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { organizationRemoteSessionsList } from "../funcs/organizationRemoteSessionsList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import {
  ListOrganizationRemoteSessionClientSessionsRequest,
  ListOrganizationRemoteSessionClientSessionsResponse,
  ListOrganizationRemoteSessionClientSessionsSecurity,
} from "../models/operations/listorganizationremotesessionclientsessions.js";
import { unwrapAsync } from "../types/fp.js";
import { PageIterator, unwrapResultIterator } from "../types/operations.js";
import { pageIteratorToJSON } from "./_types.js";
export type OrganizationRemoteSessionClientSessionsQueryData =
  ListOrganizationRemoteSessionClientSessionsResponse;

export type OrganizationRemoteSessionClientSessionsInfiniteQueryData =
  PageIterator<
    ListOrganizationRemoteSessionClientSessionsResponse,
    { cursor: string }
  >;

export type OrganizationRemoteSessionClientSessionsPageParams = PageIterator<
  ListOrganizationRemoteSessionClientSessionsResponse,
  { cursor: string }
>["~next"];

export function prefetchOrganizationRemoteSessionClientSessions(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListOrganizationRemoteSessionClientSessionsRequest,
  security?: ListOrganizationRemoteSessionClientSessionsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildOrganizationRemoteSessionClientSessionsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function prefetchOrganizationRemoteSessionClientSessionsInfinite(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListOrganizationRemoteSessionClientSessionsRequest,
  security?: ListOrganizationRemoteSessionClientSessionsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchInfiniteQuery({
    ...buildOrganizationRemoteSessionClientSessionsInfiniteQuery(
      client$,
      request,
      security,
      options,
    ),
    initialPageParam:
      undefined as OrganizationRemoteSessionClientSessionsPageParams,
    getNextPageParam: (
      previousPage: OrganizationRemoteSessionClientSessionsInfiniteQueryData,
    ) => previousPage["~next"],
  });
}

export function buildOrganizationRemoteSessionClientSessionsQuery(
  client$: GramCore,
  request: ListOrganizationRemoteSessionClientSessionsRequest,
  security?: ListOrganizationRemoteSessionClientSessionsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<OrganizationRemoteSessionClientSessionsQueryData>;
} {
  return {
    queryKey: queryKeyOrganizationRemoteSessionClientSessions({
      clientId: request.clientId,
      cursor: request.cursor,
      limit: request.limit,
      gramSession: request.gramSession,
      gramKey: request.gramKey,
    }),
    queryFn: async function organizationRemoteSessionClientSessionsQueryFn(
      ctx,
    ): Promise<OrganizationRemoteSessionClientSessionsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(organizationRemoteSessionsList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function buildOrganizationRemoteSessionClientSessionsInfiniteQuery(
  client$: GramCore,
  request: ListOrganizationRemoteSessionClientSessionsRequest,
  security?: ListOrganizationRemoteSessionClientSessionsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext<
      QueryKey,
      OrganizationRemoteSessionClientSessionsPageParams
    >,
  ) => Promise<OrganizationRemoteSessionClientSessionsInfiniteQueryData>;
} {
  return {
    queryKey: queryKeyOrganizationRemoteSessionClientSessionsInfinite({
      clientId: request.clientId,
      cursor: request.cursor,
      limit: request.limit,
      gramSession: request.gramSession,
      gramKey: request.gramKey,
    }),
    queryFn: async function organizationRemoteSessionClientSessionsQuery(
      ctx,
    ): Promise<OrganizationRemoteSessionClientSessionsInfiniteQueryData> {
      const sig = combineSignals(ctx.signal, options?.fetchOptions?.signal);
      const mergedOptions = {
        ...options,
        fetchOptions: { ...options?.fetchOptions, signal: sig },
      };

      if (!ctx.pageParam) {
        const pageResult = await unwrapResultIterator(
          organizationRemoteSessionsList(
            client$,
            request,
            security,
            mergedOptions,
          ),
        );
        return pageIteratorToJSON(pageResult);
      }
      const pageResult = await unwrapResultIterator(
        organizationRemoteSessionsList(
          client$,
          {
            ...request,
            cursor: ctx.pageParam.cursor,
          },
          security,
          mergedOptions,
        ),
      );
      return pageIteratorToJSON(pageResult);
    },
  };
}

export function queryKeyOrganizationRemoteSessionClientSessions(
  parameters: {
    clientId: string;
    cursor?: string | undefined;
    limit?: number | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "organizationRemoteSessions", "list", parameters];
}

export function queryKeyOrganizationRemoteSessionClientSessionsInfinite(
  parameters: {
    clientId: string;
    cursor?: string | undefined;
    limit?: number | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
  },
): QueryKey {
  return [
    "@gram/client",
    "organizationRemoteSessions",
    "list",
    "infinite",
    parameters,
  ];
}
